import { api } from '@/config/api';

export type AdsPlatform = 'meta' | 'tiktok' | 'google';

export interface AdsOverviewPlatformRow {
  platform: AdsPlatform;
  spend: number;
  currency: string | null;
  impressions: number;
  clicks: number;
  leads: number;
  costPerLead: number | null;
  /** Spend in the company's currency at today's rate (null when no rate). */
  spendConverted?: number | null;
  wonDeals: number;
  /** Won deal amounts, in the company's currency. */
  wonValue: number;
  roas: number | null;
  /** False when the platform has no cached insights synced yet. */
  dataAvailable: boolean;
}

export interface AdsOverviewTotals {
  /** In totalsCurrency (the company's). Null only when a platform currency has no rate. */
  spend: number | null;
  totalsCurrency: string | null;
  /** True when some platform spend was converted from its own currency. */
  converted?: boolean;
  unconverted?: string[];
  ratesAsOf?: string | null;
  impressions: number;
  clicks: number;
  leads: number;
  costPerLead: number | null;
  wonDeals: number;
  wonValue: number;
  roas: number | null;
}

export interface AdsOverviewResponse {
  range: { from: string; to: string };
  platforms: AdsOverviewPlatformRow[];
  totals: AdsOverviewTotals;
}

const BASE = '/slighter_crm/ads-overview';

export const adsOverviewService = {
  get: async (filter: { from?: string; to?: string } = {}): Promise<AdsOverviewResponse> =>
    (await api.get(BASE, { params: filter })).data,
};
